const DeclineIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width={props.size}
    height={props.size}
    fill="currentColor"
    {...props}
  >
    <polygon points="29.6,6.8 25.2,2.4 16,11.7 6.8,2.4 2.4,6.8 11.7,16 2.4,25.2 6.8,29.6 16,20.3 25.2,29.6 29.6,25.2 20.3,16 " />
  </svg>
);

export default DeclineIcon;
